var _line, _path, _line2, _line3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-image-off-icon lucide-image-off",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    x2: 22,
    y1: 2,
    y2: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 10.41a2 2 0 1 1-2.83-2.83"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    x2: 6,
    y1: 13.5,
    y2: 21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    x2: 21,
    y1: 12,
    y2: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15V5a2 2 0 0 0-2-2H9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOff);
export default __webpack_public_path__ + "static/media/image-off.b57bf4a3f056b71fae7016f2d9d2890e.svg";
export { ForwardRef as ReactComponent };